import vehicleId from './vehicleId';
import pageAlias from './pageAlias';
import tabList from './tabList';
import paymentInfo from './pricingInfo';
import vehicleInfo from './vehicleInfo';
import widgetClasses from './widgetClasses';
import locale from './locale';


const root = {
	vehicleId,
	pageAlias,
	tabList,
	paymentInfo,
	vehicleInfo,
	widgetClasses,
	locale
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js